import React from "react";
import { CookieConsentDialogProps } from "../types/CookieConsentDialogProps";
import "./cookieConcentDialog.css";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { SmallInputSwitch } from "../SmallInputSwitch/SmallInputSwitch";

export const CookieConsentDialog = ({
    onToggleAnalyticsCookies,
    onHide,
    analyticCookiesEnabled,
    visible,
    dataPrivacyLink
}: CookieConsentDialogProps) => {
    const { t } = useTranslation("common");

    return (
        <Dialog
            className="dialog-medium"
            header={`${t("cookieDialog.title")}`}
            headerClassName="font-semibold header-text"
            visible={visible}
            onHide={onHide}
            keepInViewport
        >
            <div className="grid p-fluid">
                <div className="col-12">
                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.introduction"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.introductionSection"
                    )}`}</p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.whatAreCookies"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.whatAreCookiesSection"
                    )}`}</p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.cookieType"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.cookieTypeSection"
                    )}`}</p>

                    <Divider />

                    <div className="cookieDialog__toggleContainer">
                        <h2 className="cookieDialog__sectionHeader">{`${t(
                            "cookieDialog.essentialCookies"
                        )}`}</h2>
                        <SmallInputSwitch
                            checked={true}
                            disabled
                            onChange={onToggleAnalyticsCookies}
                        />
                    </div>

                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.essentialCookiesSection"
                    )}`}</p>

                    <Divider />

                    <div className="cookieDialog__toggleContainer">
                        <h2 className="cookieDialog__sectionHeader">{`${t(
                            "cookieDialog.analyticCookies"
                        )}`}</h2>
                        <SmallInputSwitch
                            checked={analyticCookiesEnabled}
                            onChange={onToggleAnalyticsCookies}
                        />
                    </div>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.analyticCookiesSection"
                    )}`}</p>

                    <Divider />

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.whatData"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.theDataCollected"
                    )}`}</p>
                    <p className="cookieDialog__sectionText">
                        {`${t("cookieDialog.ipAddress")}`}
                        <br></br>
                        {`${t("cookieDialog.deviceType")}`}
                        <br></br>
                        {`${t("cookieDialog.dateAndTime")}`}
                        <br></br>
                        {`${t("cookieDialog.pagesYouVisit")}`}
                        <br></br>
                        {`${t("cookieDialog.loginDetails")}`}
                        <br></br>
                        {`${t("cookieDialog.browsingBehaviour")}`}
                        <br></br>
                    </p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.cookieConsent"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.cookieConsentSection"
                    )}`}</p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.dataPrivacy"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.dataPrivacySection"
                    )}`}</p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.internationalDataTransfers"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">{`${t(
                        "cookieDialog.internationalDataTransfersSection"
                    )}`}</p>

                    <h2 className="cookieDialog__sectionHeader">{`${t(
                        "cookieDialog.contactUs"
                    )}`}</h2>
                    <p className="cookieDialog__sectionText">
                        {`${t("cookieDialog.contactUsSection")}`}{" "}
                        <a href={dataPrivacyLink}>{dataPrivacyLink}</a>
                    </p>
                </div>
            </div>
        </Dialog>
    );
};
